function bindRestaurantCardToMap(container) {
	const card = container.querySelector('.location-card');
	if (!card) return;

	const mapId = card.dataset.mapId;
	if (!mapId) return;

	let currentRestaurantId = 0;

	document.addEventListener('map:restaurant-selected', (e) => {
		const { mapId: eventMapId, data } = e.detail;

		// Only respond to events from this map
		if (eventMapId !== mapId) return;

		// Only update if it's a different restaurant
		if (data.id === currentRestaurantId) return;

		currentRestaurantId = data.id;

		// Update address
		const addressTextEl = card.querySelector(
			'.location-card__text--address'
		);

		if (addressTextEl) {
			const addressParts = [];
			if (data.acf?.address) addressParts.push(data.acf.address);
			if (data.acf?.city) addressParts.push(data.acf.city);
			if (data.acf?.additional_address_info)
				addressParts.push(data.acf.additional_address_info);

			addressTextEl.textContent = addressParts.join(', ');
		}

		// Update address link
		const addressLink = card.querySelector('.location-card__action a');
		if (addressLink) {
			addressLink.href = data.acf?.address_link || '#';
		}

		// Update work hours
		const workHoursEl = card.querySelector(
			'.location-card__text--schedule'
		);
		const schedules = data.acf?.schedules || [];

		if (workHoursEl) {
			workHoursEl.innerHTML = '';

			schedules.forEach((item, index, arr) => {
				const scheduleSpan = document.createElement('span');
				const comma = index < arr.length - 1 ? ',' : '';
				scheduleSpan.textContent = `${item.schedule}${comma}`;
				workHoursEl.appendChild(scheduleSpan);
			});
		}

		// Update phone
		const phoneEl = card.querySelector('.location-card__text--phone a');
		if (phoneEl) {
			const phone = data.acf?.phone_number || '';
			phoneEl.href = phone ? `tel:${phone}` : '#';
			phoneEl.textContent = phone || '';
		}

		// Update logos
		const cancanLogo = card.querySelector(
			'.location-card__logo:not(.location-card__logo--kakemake)'
		);
		const kakeMakeLogo = card.querySelector(
			'.location-card__logo--kakemake'
		);

		if (kakeMakeLogo) {
			if (data.acf?.has_kake_make) {
				kakeMakeLogo.classList.remove('invisible');
			} else {
				kakeMakeLogo.classList.add('invisible');
			}
		}

		// Update food ordering links
		const pickupEl = card.querySelector('a.pickup-on-site');
		if (pickupEl)
			pickupEl.href = data.acf?.food_ordering?.pickup_on_site || '#';

		const boltEl = card.querySelector('a.bolt');
		if (boltEl) boltEl.href = data.acf?.food_ordering?.bolt || '#';

		const woltEl = card.querySelector('a.wolt');
		if (woltEl) woltEl.href = data.acf?.food_ordering?.wolt || '#';
	});
}

document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('.wp-block-cancan-location-card')
		.forEach((locationCard) => {
			bindRestaurantCardToMap(locationCard);
		});
});
